import React from 'react';
import { Card, Statistic, Row, Col } from 'antd';
import { DollarOutlined, GiftOutlined, ShoppingOutlined, WalletOutlined } from '@ant-design/icons';

interface ExpensesWidgetProps {
  totalExpenses: number;
  totalDonates: number;
  totalSales: number;
  currentBalance: number;
}

const ExpensesWidget: React.FC<ExpensesWidgetProps> = ({
  totalExpenses,
  totalDonates,
  totalSales,
  currentBalance,
}) => {
  return (
    <Card title="Expenses Overview" bordered={false} className="dashboard-card">
      <Row gutter={[16, 24]} justify="space-around">
        <Col xs={24}>
          <Statistic
            title="Total Expenses"
            value={totalExpenses}
            precision={2}
            valueStyle={{ color: '#cf1322', fontSize: '24px' }}
            prefix={<DollarOutlined />}
            suffix="$"
          />
        </Col>
        <Col xs={24}>
          <Statistic
            title="Total Donations"
            value={totalDonates}
            precision={2}
            valueStyle={{ color: '#3f8600', fontSize: '24px' }}
            prefix={<GiftOutlined />}
            suffix="$"
          />
        </Col>
        <Col xs={24}>
          <Statistic
            title="Total Sales"
            value={totalSales}
            precision={2}
            valueStyle={{ color: '#1890ff', fontSize: '24px' }}
            prefix={<ShoppingOutlined />}
            suffix="$"
          />
        </Col>
        <Col xs={24}>
          <Statistic
            title="Current Balance"
            value={currentBalance}
            precision={2}
            valueStyle={{ color: currentBalance >= 0 ? '#3f8600' : '#cf1322', fontSize: '24px' }}
            prefix={<WalletOutlined />}
            suffix="$"
          />
        </Col>
      </Row>
    </Card>
  );
};

export default ExpensesWidget;
